"use strict";

var _Object$keys = require("@babel/runtime-corejs3/core-js-stable/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");
var _filterInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/filter");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useResizeObserver = exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/slicedToArray"));
var _react = require("react");
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
var useResizeObserver = exports.useResizeObserver = function useResizeObserver() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    disconnect = _ref.disconnect,
    onResize = _ref.onResize,
    getResizeElement = _ref.getResizeElement,
    targetRef = _ref.targetRef;
  var resizeObserverRef = (0, _react.useRef)(null);
  var observedElementRef = (0, _react.useRef)(null);
  var _useState = (0, _react.useState)({
      width: undefined,
      height: undefined
    }),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    dimensions = _useState2[0],
    setDimensions = _useState2[1];
  var disconnectObserver = function disconnectObserver() {
    var _resizeObserverRef$cu, _resizeObserverRef$cu2;
    observedElementRef.current = null;
    (_resizeObserverRef$cu = resizeObserverRef.current) === null || _resizeObserverRef$cu === void 0 || (_resizeObserverRef$cu2 = _resizeObserverRef$cu.disconnect) === null || _resizeObserverRef$cu2 === void 0 || _resizeObserverRef$cu2.call(_resizeObserverRef$cu);
  };
  var handleResize = function handleResize(resizedElements) {
    var targetNode = resizedElements === null || resizedElements === void 0 ? void 0 : resizedElements[0];
    var targetElement = targetNode === null || targetNode === void 0 ? void 0 : targetNode.target;
    var newWidth = targetElement === null || targetElement === void 0 ? void 0 : targetElement.offsetWidth;
    var newHeight = targetElement === null || targetElement === void 0 ? void 0 : targetElement.offsetHeight;
    var widthChanged = newWidth !== (dimensions === null || dimensions === void 0 ? void 0 : dimensions.width);
    var heightChanged = newHeight !== (dimensions === null || dimensions === void 0 ? void 0 : dimensions.height);
    if (widthChanged || heightChanged) {
      var newDimensions = _objectSpread(_objectSpread({}, dimensions), {}, {
        width: newWidth,
        height: newHeight
      });
      setDimensions(newDimensions);
      onResize === null || onResize === void 0 || onResize(newDimensions);
    }
  };
  var observeNewElement = function observeNewElement(element) {
    if (observedElementRef.current === element) {
      return;
    }
    disconnectObserver();
    observedElementRef.current = element;
    if (element) {
      var _resizeObserverRef$cu3, _resizeObserverRef$cu4;
      if (!resizeObserverRef.current) {
        resizeObserverRef.current = new ResizeObserver(handleResize);
      }
      (_resizeObserverRef$cu3 = (_resizeObserverRef$cu4 = resizeObserverRef.current).observe) === null || _resizeObserverRef$cu3 === void 0 || _resizeObserverRef$cu3.call(_resizeObserverRef$cu4, element);
    }
  };
  (0, _react.useEffect)(function () {
    if (disconnect) {
      disconnectObserver();
    } else if (targetRef !== null && targetRef !== void 0 && targetRef.current) {
      observeNewElement((getResizeElement === null || getResizeElement === void 0 ? void 0 : getResizeElement(targetRef.current)) || targetRef.current);
    }
    return function () {
      disconnectObserver();
    };
  }, [disconnect]);
  return _objectSpread(_objectSpread({}, dimensions), {}, {
    observeNewElement: observeNewElement,
    disconnectObserver: disconnectObserver,
    observedElement: observedElementRef.current
  });
};
var _default = exports.default = useResizeObserver;